




























































































// import { Component, Vue, Watch } from "vue-property-decorator";
import { Component, Vue } from "vue-property-decorator";
import {
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  CellGroup,
  Cell,
  Button,
  Icon,
  Toast,
  Dialog
} from "vant";
@Component({
  name: "RiskQuestionnaire",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  }
})
export default class RiskQuestionnaire extends Vue {
  questions: any = [];
  isBtn: any = false;
  checkOption: any = JSON.parse(
    window.localStorage.getItem("accountOpenObject") || ""
  );
  curDay: any = new Date().getFullYear();
  get btnText() {
    return this.$t("assessment.question.btnText");
  }
  get titleText() {
    return this.$t("assessment.question.titleText");
  }
  get titleMark() {
    return this.$t("assessment.question.titleMark");
  }
  // eslint-disable-next-line getter-return
  get getAgeRange() {
    const { birth } = this.checkOption;
    const isBirth = this.curDay - Number(birth);
    let num;
    if (isBirth >= 18 && isBirth <= 35) {
      num = "a";
    } else if (isBirth >= 36 && isBirth < 44) {
      num = "b";
    } else if (isBirth >= 44 && isBirth < 55) {
      num = "c";
    } else if (isBirth >= 55 && isBirth <= 65) {
      num = "d";
    } else if (isBirth > 65) {
      num = "e";
    }
    return num;
  }
  get isOptional4() {
    const { pageTwo } = JSON.parse(JSON.stringify(this.checkOption));
    pageTwo.splice(0, 1);
    pageTwo.splice(3, 1);
    pageTwo.splice(4, 1);
    if (pageTwo.length > 0) {
      return !pageTwo.some(function(value, index) {
        return value !== 1;
      });
    } else {
      return true;
    }
  }
  get isOptional5() {
    const { pageTwo } = JSON.parse(JSON.stringify(this.checkOption));
    pageTwo.splice(1, 1);
    pageTwo.splice(1, 1);
    pageTwo.splice(1, 1);
    pageTwo.splice(2, 1);
    if (pageTwo.length > 0) {
      return !pageTwo.some(function(value, index) {
        return value !== 1;
      });
    } else {
      return true;
    }
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  activated() {
    this.questions.forEach(item => item.result && delete item.result);
    this.checkOption = JSON.parse(
      window.localStorage.getItem("accountOpenObject") || ""
    );
    this.$forceUpdate();
  }

  created() {
    this.questions = this.$t("assessment.question.question");
  }

  toggleCheckBox(i, item) {
    (this as any).$refs[item.ref][i].toggle();
  }

  onClickRadio(child, index) {
    
    
    const { name } = child;
    const isAllEqual = this.isOptional4;
    const isAllEqual5 = this.isOptional5;
    this.$set(this.questions[index], "result", child.name);
    let isReturn = false;
    switch (index) {
      case 0:
        if (this.getAgeRange !== name) {
          Dialog.alert({
            message: `${this.$t('assessment.question.derivative_clew')}`,
            ["className" as any]: document.getElementsByClassName('black-theme')[0] ? 'black-theme-dialog' : ''
          }).then(() => {
            this.questions[index].result = ''
          });
          isReturn = true;
          this.isBtn = true;
        } else {
          this.isBtn = false;
        }
        break;
      case 3:
        if ((isAllEqual && name !== "a") || (!isAllEqual && name == "a")) {
          isReturn = true;
          Dialog.alert({
            message: `${this.$t('assessment.question.derivative_clew_two')}`,
            ["className" as any]: document.getElementsByClassName('black-theme')[0] ? 'black-theme-dialog' : ''
          }).then(() => {
            this.questions[index].result = ''
          });
          this.isBtn = true;
        } else {
          this.isBtn = false;
        }
        break;
      case 4:
        if ((isAllEqual5 && name !== "a") || (!isAllEqual5 && name == "a")) {
          isReturn = true;
          Dialog.alert({
            message: `${this.$t('assessment.question.derivative_clew_two')}`,
            ["className" as any]: document.getElementsByClassName('black-theme')[0] ? 'black-theme-dialog' : ''
          }).then(() => {
            this.questions[index].result = ''
          });
          this.isBtn = true;
        } else {
          this.isBtn = false;
        }
        break;
      default:
        break;
    }
    if (isReturn) {
      this.$set(this.questions[index], "result", "");
    }
  }

  handleButtonClick() {
    for (let i = 0, len = this.questions.length; i < len; i++) {
      const item = this.questions[i];
      if (
        item.isMust &&
        ((!item.isCheck && !item.result) ||
          (item.isCheck && (!item.result || !item.result.length)))
      ) {
        const el = document.querySelector(`.question${i + 1}`);
        el && el.scrollIntoView(true);
        Toast(this.$t("assessment.question.toastMsg"));
        return;
      }
    }
    const params = {
      content: this.questions
    };
    (this as any).$apis
      .postRiskAssessment(params)
      .then(() => {
        this.$router.replace({ name: "AssessmentResult" });
      })
      .catch(e => {
        
      });
  }

  // @Watch("questions", { deep: true, immediate: true })
  // watchValue(val) {
  //   this.isFullSelect = val.every(
  //     item =>
  //       item.isMust &&
  //       ((!item.isCheck && item.result) ||
  //         (item.isCheck && item.result && item.result.length))
  //   );
  // }
}
